document.addEventListener("DOMContentLoaded", async () => {
    const CACHE_KEY = "allProducts";

    // If already stored, log it and exit
    if (localStorage.getItem(CACHE_KEY)) {
    

        const cachedProducts = JSON.parse(localStorage.getItem(CACHE_KEY));
        

        // Check first product description
       
        return;
    }

    try {
        const products = await fetchAllProductsFromStorefront();

        localStorage.setItem(CACHE_KEY, JSON.stringify(products));

     
    } catch (error) {
        console.error("Failed to load products:", error);
    }
});



async function fetchAllProductsFromStorefront() {
    const products = [];
    let page = 1;
    const limit = 250;

    while (true) {
        const res = await fetch(`/products.json?limit=${limit}&page=${page}`);
        if (!res.ok) break;

        const data = await res.json();
        const batch = data?.products || [];

        if (!batch.length) break;

        batch.forEach((p) => {
            products.push({
                id: String(p.id),
                title: p.title || "",
                handle: p.handle || "",
                body_html: p.body_html || "",
                tags: typeof p.tags === "string"
                    ? p.tags.split(",").map((t) => t.trim()).filter(Boolean)
                    : (p.tags || []),
            });
        });

        if (batch.length < limit) break; // last page
        page += 1;
    }

    return products;
}

// =========================
// CONSTANTS & GLOBALS
// =========================
const SHOP_DOMAIN = "joyorganics.myshopify.com";

const ALL_CANNA_VALUES = ["THC-FREE", "CBD-THC", "HIGH-THC", "CBG-CBD"];
const ALL_BENEFIT_VALUES = ["Relax", "Sleep", "Joint", "Buzz", "Muscle", "Skin", "focus", "Inflammation"];

const CATEGORY_FILTERS = [
  { label: "Gummies",     metafield: "product_gummiess" },
  { label: "Tinctures",  metafield: "product_tinctures" },
  { label: "Softgels",   metafield: "product_softgels" },
  { label: "CBD Topicals", metafield: "cbd_topicals" },
  { label: "CBD Pet",    metafield: "cbd_pet" },
];

const SEARCH_PAGE_URL = "/search";
const YOTPO_APP_KEY = "q4VHCrEpW3gVedIg22FOYhJYAavS5Ilh8LbEFAT3";
const PRODUCT_DETAIL_ENDPOINT = "https://ce.joyorganics.com/product-detail";

let allProducts = [];
let currentSearchQuery = "";
let activeFilterName = null;
let activeFilterVal = null;

// =========================
// BLOCKED PRODUCT IDS
// =========================
const OIL_BLOCKED_IDS = ["4015028306019", "10412535775413", "4015027454051", "4015027486819", "10412532957365"];
const SUBSCRIPTION_BLOCKED_IDS = ["6993939431605", "4726629433443", "6840216387765", "7248726065333", "8018874892469", "7463360004277", "7230817435829", "7209454796981", "10280832827573", "7449352896693"];

const ANXIETY_EXCLUDED_IDS = new Set([
  "4449044562019", "6001381998773", "10327261413557", "4510438752355",
  "7838940397749", "7838961729717", "7858304057525", "7858304516277",
  "7858305171637", "7858331320501", "7815279968437", "10330145030325",
]);

const TINCTURE_BLOCKED_IDS = ["4015027486819", "10412532957365", "10541685506229"];

// =========================
// UTILITY HELPERS
// =========================
function applyOilProductRules(products, query) {
  if (!query?.toLowerCase().includes("oil")) return products;
  return products.filter((p) => !OIL_BLOCKED_IDS.includes(String(p.id)));
}

function applyTinctureProductRules(products, query) {
  if (!query?.toLowerCase().includes("tincture")) return products;
  const filtered = products.filter((p) => !TINCTURE_BLOCKED_IDS.includes(String(p.id)));
  return filtered;
}

function deduplicateByTitle(products) {
  const map = new Map();

  products.forEach((product) => {
    const key = (product.title || "").trim().toLowerCase();
    const hasSubscription = product.sellingPlans?.length > 0;

    if (!map.has(key)) {
      map.set(key, product);
      return;
    }

    const existing = map.get(key);
    if (!existing.sellingPlans?.length && hasSubscription) {
      map.set(key, product);
    }
  });

  return [...map.values()];
}

function parseMetafieldArray(value) {
  if (!value) return [];

  try {
    const parsed = JSON.parse(value);
    const items = Array.isArray(parsed) ? parsed : [parsed];

    return items.map((item) => {
      if (typeof item === "object") return item.title || item.name || item.value || "";
      return item;
    }).filter(Boolean);
  } catch {
    return value.split(",").map((x) => x.trim()).filter(Boolean);
  }
}

function storeRecentSearch(term) {
  let recent = JSON.parse(localStorage.getItem("recentSearches") || "[]");
  recent = [term, ...recent.filter((item) => item !== term)].slice(0, 10);
  localStorage.setItem("recentSearches", JSON.stringify(recent));
}

// =========================
// NORMALIZE PRODUCT-DETAIL RESPONSE
// =========================

function normalizeDetailResponse(raw) {
  const node = raw?.product;
  if (!node) return null;

  // metafields.nodes -> flat { shop_by_benefits: "...", strength: "...", ... }
  // (keys come back as "custom.shop_by_benefits", so strip the "custom." prefix)
  const metafields = {};
  (node.metafields?.nodes || []).forEach((m) => {
    if (!m?.key) return;
    const key = m.key.replace(/^custom\./, "");
    metafields[key] = m.value;
  });

  const benefits = [
    ...new Set(
      parseMetafieldArray(metafields.shop_by_benefits).filter(
        (b) => b && b.toLowerCase() !== "customstrength"
      )
    ),
  ];

  const productTypes = [...new Set(parseMetafieldArray(metafields.custom_product_category))];

  
  const variants = (node.variants?.edges || []).map((e) => {
    const v = e.node || {};
    const basePrice = parseFloat(v.price || "0") || 0;

    const plans =
      v.sellingPlanGroups?.edges?.flatMap(
        (g) => g?.node?.sellingPlans?.nodes || []
      ) || [];

    const sellingPlanAllocations = {
      edges: plans.map((plan) => {
        const policy = (plan.pricingPolicies || [])[0];
        let subPrice = basePrice;

        if (policy?.adjustmentType === "PERCENTAGE") {
          const pct = policy.adjustmentValue?.percentage || 0;
          subPrice = basePrice * (1 - pct / 100);
        } else if (policy?.adjustmentType === "FIXED_AMOUNT") {
          const amt = parseFloat(policy.adjustmentValue?.amount || "0") || 0;
          subPrice = Math.max(basePrice - amt, 0);
        } else if (policy?.adjustmentType === "PRICE") {
          subPrice = parseFloat(policy.adjustmentValue?.price?.amount || basePrice) || basePrice;
        }

        return {
          node: {
            sellingPlan: { id: plan.id || "", name: plan.name || "" },
            priceAdjustments: [
              {
                price: { amount: subPrice ? subPrice.toFixed(2) : "" },
                compareAtPrice: { amount: v.compareAtPrice || "" },
                perDeliveryPrice: { amount: subPrice ? subPrice.toFixed(2) : "" },
              },
            ],
          },
        };
      }),
    };

    return {
      id: v.id || "",
      title: v.title || "",
      availableForSale: !!v.availableForSale,
      selectedOptions: v.selectedOptions || [],
      image: v.image || null,
      price: { amount: v.price ?? "0" },
      compareAtPrice: { amount: v.compareAtPrice ?? "" },
      sellingPlanAllocations,
    };
  });

  const sellingPlanMap = new Map();
  variants.forEach((v) => {
    (v.sellingPlanAllocations?.edges || []).forEach((sp) => {
      const plan = sp?.node?.sellingPlan;
      if (!plan?.name) return;
      const id = plan.id || "";
      sellingPlanMap.set(plan.name, {
        id,
        numericId: id ? id.split("/").pop() : "",
        name: plan.name,
        subscriptionPrice: sp?.node?.priceAdjustments?.[0]?.price?.amount || "",
      });
    });
  });

  return {
    id: (node.id || "").split("/").pop() || "",
    title: node.title || "",
    handle: node.handle || "",
    image: node.images?.edges?.[0]?.node?.url || "",
    price: variants[0]?.price?.amount || "0",
    variants,
    metafields,
    sellingPlans: Array.from(sellingPlanMap.values()),
    benefit: benefits,
    tags: node.tags || [],
    productType: productTypes,
  };
}

// =========================
// FETCH PRODUCTS (CACHE LOOKUP + DETAIL ENDPOINT)
// =========================

// Fetches full normalized product detail for a list of product ids via the
// product-detail endpoint (no Storefront API token required).
async function fetchProductDetailsByIds(ids) {
    const uniqueIds = [
        ...new Set(
            (ids || []).map((id) =>
                String(id).replace("gid://shopify/Product/", "")
            )
        )
    ];

    const results = await Promise.all(
        uniqueIds.map(async (id) => {
            try {
                const res = await fetch(`${PRODUCT_DETAIL_ENDPOINT}/${id}`);
                if (!res.ok) return null;

                const raw = await res.json();

                // Normalize response ID as well
                raw.id = String(raw.id).replace("gid://shopify/Product/", "");

                return normalizeDetailResponse
                    ? normalizeDetailResponse(raw)
                    : raw;
            } catch (err) {
                console.error(`Failed to fetch detail for product ${id}:`, err);
                return null;
            }
        })
    );

    return results.filter(Boolean);
}


async function fetchCollectionProductIds(handles) {
    const idSet = new Set();

    await Promise.all(
        handles.map(async (handle) => {
            let page = 1;
            const limit = 250;

            while (true) {
                let res;
                try {
                    res = await fetch(`/collections/${handle}/products.json?limit=${limit}&page=${page}`);
                } catch (err) {
                    console.error(`Failed to fetch collection ${handle}:`, err);
                    break;
                }

                if (!res.ok) break;

                const data = await res.json();
                const batch = data?.products || [];

                if (!batch.length) break;

                batch.forEach((p) => idSet.add(String(p.id)));

                if (batch.length < limit) break; // last page
                page += 1;
            }
        })
    );

    return [...idSet];
}

async function fetchCollectionProducts(...handles) {
    try {
        const ids = await fetchCollectionProductIds(handles);
        return await fetchProductDetailsByIds(ids);
    } catch (err) {
        console.error(err);
        return [];
    }
}

async function fetchProducts(query) {
    const q = query.toLowerCase().trim();

    if (!q) return [];

    if (q.includes("anxiety")) {
        const products = await fetchCollectionProducts(
            "cbd-for-joint-muscle-support",
            "cbd-for-sleep",
            "cbd-for-stress-support",
            "premium-thc-products-for-a-booze-free-buzz"
        );

        return products.filter(
            (p) => !ANXIETY_EXCLUDED_IDS.has(String(p.id))
        );
    }

    if (q.includes("pain")) {
        return fetchCollectionProducts(
            "cbd-for-joint-muscle-support",
            "cbd-for-sleep",
            "cbd-for-stress-support",
            "premium-thc-products-for-a-booze-free-buzz"
        );
    }

    if (q.includes("melatonin")) {
        return fetchCollectionProducts(
            "shop-sleep-gummies",
            "sleep-gummies-and-softgels"
        );
    }

    const products = JSON.parse(localStorage.getItem("allProducts") || "[]");

    const words = q.split(/\s+/).filter(Boolean);

    const matchedProducts = products.filter(product => {

        const searchable = [
            product.title,
            product.handle,
            product.body_html,
            product.vendor,
            product.product_type,
            ...(product.tags || [])
        ]
        .join(" ")
        .toLowerCase();

        return words.every(word => searchable.includes(word));
    });

    return fetchProductDetailsByIds(
        matchedProducts.map(p => p.id)
    );
}


async function fetchPredictiveSuggestions(query) {
  try {
    const res = await fetch(
      `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=query&resources[limit]=8`
    );
    const data = await res.json();
    return data?.resources?.results?.queries || [];
  } catch (err) {
    console.error("Suggestion Error:", err);
    return [];
  }
}

async function fetchArticles(query) {
  try {
    const res = await fetch(
      `/search?q=${encodeURIComponent(query)}&options[prefix]=last&type=article`
    );
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    const articlesMap = new Map();

    doc.querySelectorAll(".article-card-wrapper, .article-card").forEach((card) => {
      const link = card.querySelector('a[href*="/blogs/"]');
      if (!link) return;

      const url = link.href;
      if (articlesMap.has(url)) return;

      articlesMap.set(url, {
        title: card.querySelector("h2, h3, .card__heading")?.textContent?.trim() || "",
        url,
        image: card.querySelector("img")?.src || "",
      });
    });

    const articles = Array.from(articlesMap.values());

    if (query?.toLowerCase().includes("reward")) {
      articles.unshift({
        title: "Rewards Program",
        url: "/pages/loyalty",
        image: "https://joyorganics.com/cdn/shop/files/loyality-banner-mobile.jpg?v=1762351486&width=390",
        isRewardPage: true,
      });
    }

    return articles;
  } catch (err) {
    console.error(err);
    return [];
  }
}

// =========================
// POPUP OPEN / CLOSE
// =========================
function openPopup() {
  document.querySelector(".js-search-suggestions-popup")?.classList.add("is-active");
}

function closePopup() {
  document.querySelector(".js-search-suggestions-popup")?.classList.remove("is-active");
}

function showLoader() {
 
  document.querySelector(".eq-header__search-button")?.classList.add("is-loader-visible");
  document.querySelector(".js-search-block")?.classList.remove("shown-suggestions-popup");
}

function hideLoader() {
  document.querySelector(".eq-header__search-button")?.classList.remove("is-loader-visible");
  document.querySelector(".js-search-block")?.classList.add("shown-suggestions-popup");
}

// =========================
// MAIN SEARCH
// =========================
let mainSearchResults = [];
async function search(q) {
  currentSearchQuery = q;
  openPopup();
  showLoader();

  try {
    let [products, blogs] = await Promise.all([fetchProducts(q), fetchArticles(q)]);

    products = applyOilProductRules(products, q);
    products = applyTinctureProductRules(products, q);
    allProducts = products;
    mainSearchResults = products;

    renderProducts(products);
    buildFilters(products);
    buildCannabinoids(products);
    buildCategoryFilters(products);
    renderBlogs(blogs);
    await renderSuggestions(q);

    storeRecentSearch(q);
    $(".pdp-radio--option:checked").trigger("change");
  } catch (err) {
    console.error(err);
  } finally {
    hideLoader();
  }
}

// =========================
// RENDER PRODUCTS
// =========================
function renderProducts(products) {
  const deduplicated = deduplicateByTitle(products);
  const orderedProducts = [
  ...deduplicated.filter(p => {
    const isBundled = (p.tags || []).some(
      tag => tag.toLowerCase() === "bundled"
    );
    const hasPackInTitle = (p.title || "").toLowerCase().includes("pack");

    return !isBundled && !hasPackInTitle;
  }),

    ...deduplicated.filter(p => {
      const isBundled = (p.tags || []).some(
        tag => tag.toLowerCase() === "bundled"
      );
      const hasPackInTitle = (p.title || "").toLowerCase().includes("pack");

      return isBundled || hasPackInTitle;
    })
  ];

  const total = orderedProducts.length;
  const displayed = orderedProducts.slice(0, 9);

  const el = document.querySelector(".suggestions-product__product-row");
  const countEl = document.querySelector(".suggestions-product__product-result-text span");
  const productButton = document.querySelector(".suggestions-product__product-button");

  if (!el) return;

  if (productButton) {
    productButton.style.display = total < 9 ? "none" : "flex";
  }

  if (countEl) {
    countEl.innerHTML = `${displayed.length} Search Results for '${currentSearchQuery}'`;
  }

  if (!displayed.length) {
    el.innerHTML = `<div class="no-product-found">No products found</div>`;
    document.querySelector(".suggestions-product__filters").style.display = "none";
    document.querySelector(".view-all-button").style.display = "none";
    document.querySelector(".suggestions-product__product-result-text").style.display = "none";
    el.classList.add("js-no-data");
    document.querySelector('button[data-tab="blogs"]').click();
    return;
  }

  document.querySelector(".suggestions-product__filters").style.display = "block";
  document.querySelector(".view-all-button").style.display = "block";
  document.querySelector(".suggestions-product__product-result-text").style.display = "block";
  el.classList.remove("js-no-data");
  document.querySelector('button[data-tab="products"]').click();

  el.innerHTML = displayed.map((p, index) => renderProductCard(p, index)).join("");

  setTimeout(() => {
    if (window.yotpoWidgetsContainer?.initWidgets) yotpoWidgetsContainer.initWidgets();
    else if (window.yotpo?.initWidgets) window.yotpo.initWidgets();
  }, 1000);
    
   setTimeout(() => {
    initMatchHeight();
  }, 500);

}

function renderProductCard(p, index) {
  const productId = Number(p.id);
  const variants = p.variants || [];
  const defaultVariant =
    variants.find((v) => v.title === p.metafields?.default_strength) || variants[0];
  const subscriptionPrice =
    defaultVariant?.sellingPlanAllocations?.edges?.[0]?.node?.priceAdjustments?.[0]?.price?.amount || "";

  return `
    <div class="suggestions-product__product-col card-information">
      <div class="suggestions-product__product-block suggestions-product__card-outer custom-product-card">
        <div class="card-wrapper product-card-wrapper">
          <div class="card card--card card--media color-scheme-2 gradient">

            <div class="card__inner ratio">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <a href="/products/${p.handle}">
                    <img
                      src="${p.image}&width=533"
                      srcset="
                        ${p.image}&width=165 165w,
                        ${p.image}&width=360 360w,
                        ${p.image}&width=533 533w,
                        ${p.image} 536w
                      "
                      sizes="(min-width: 1200px) 267px,
                            (min-width: 990px) calc((100vw - 130px) / 4),
                            (min-width: 750px) calc((100vw - 120px) / 3),
                            calc((100vw - 35px) / 2)"
                      alt="${p.title}"
                      class="motion-reduce"
                      loading="lazy"
                      width="536"
                      height="493"
                    >
                  </a>
                </div>
              </div>
            </div>

            <div class="card__content">
              <div class="card__information">

                <h3 class="card__heading h5">
                  <a href="/products/${p.handle}" class="full-unstyled-link">${p.title}</a>
                </h3>

                ${p.benefit?.length ? renderBenefitBadges(p.benefit) : ""}

                <div class="yotpo bottomLine"
                  data-appkey="${YOTPO_APP_KEY}"
                  data-domain="${SHOP_DOMAIN}"
                  data-product-id="${p.id}"
                  data-product-models="${p.id}"
                  data-name="${p.title}"
                  data-url="https://${SHOP_DOMAIN}/products/${p.handle}"
                  data-image-url="${p.image}">
                </div>

                <form method="post" action="/cart/add" class="js-eq-quiz-product-page-form">

                  ${variants.length ? renderVariantSelect(variants) : ""}
                  ${renderStrengthSelector(p, index)}

                  <div class="eq-product-price">
                    <a href="javascript:;" class="one-time-atc">
                      <p>One-Time Purchase</p>
                      <span class="product-one-time-price">$${p.price}</span>
                    </a>
                  </div>

                  <div class="eq-product-price eq-product-price--save-and-sub js-eq-product-price--save-and-sub">
                    ${p.sellingPlans?.length && !SUBSCRIPTION_BLOCKED_IDS.includes(String(p.id)) ? renderSubscribeSection(p, subscriptionPrice) : ""}
                  </div>

                </form>

                <div class="eq-collection-product-btn">
                  <a href="/products/${p.handle}">Learn More</a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  `;
}

function renderBenefitBadges(benefits) {
  return `
    <div class="eq-collection-benefits-badge">
      <ul>
        ${benefits.map((b) => `
          <li class="eq-badge eq-${b.toLowerCase()}-badge">
            <span>${b}</span>
          </li>
        `).join("")}
      </ul>
    </div>
  `;
}

function renderVariantSelect(variants) {
  return `
    <select name="id" class="js_product_var_change actual-variants" style="display:none;">
      ${variants.map((v, i) => {
        const price = parseFloat(v.price?.amount || 0);
        const subPrice = parseFloat(
          v.sellingPlanAllocations?.edges?.[0]?.node?.priceAdjustments?.[0]?.price?.amount || 0
        );
        const subPer = price && subPrice ? Math.round(((price - subPrice) / price) * 100) : 0;
        const variantId = v.id?.split("/").pop() || "";

        return `
          <option
            value="${variantId}"
            data-option1="${v.selectedOptions?.[0]?.value?.toLowerCase() || ""}"
            data-option2="${v.selectedOptions?.[1]?.value?.toLowerCase() || ""}"
            data-option3="${v.selectedOptions?.[2]?.value?.toLowerCase() || ""}"
            data-price="$${v.price?.amount || ""}"
            data-money_without-currency-price="${Math.round(price * 100)}"
            data-compareat-price="$${v.compareAtPrice?.amount || ""}"
            data-subscription-price="$${subPrice}"
            data-sub-per="${subPer}"
            data-image="${v.image?.url || ""}"
            data-available="${v.availableForSale || false}"
            ${i === 0 ? "selected" : ""}
          >${v.title}</option>
        `;
      }).join("")}
    </select>
  `;
}

function renderStrengthSelector(p, index) {
  const productId = Number(p.id);
  const variants = p.variants || [];

  const metaStrength = p.metafields?.strength || "";
  const defaultStrength = p.metafields?.default_strength || "";

  const labelText =
    productId === 6001381998773 ? "Size:" : "Strength:";

  // Same as card_product.has_only_default_variant
  const hasOnlyDefaultVariant =
    variants.length === 1 &&
    (variants[0].title === "Default Title" || !variants[0].title);

  // -----------------------------
  // has_only_default_variant
  // -----------------------------
  if (hasOnlyDefaultVariant) {
    if (!metaStrength) return "";

    return `
      <div class="product_value eq-product-detail-strength__wrap-left eq-collection--height" data-input-type="radio">
        <div class="custom_variant_selection">
          <label>${labelText}</label>
          <div class="wrapper">
            <div class="form-grp">
              <input
                type="radio"
                class="custom-meta-strength"
                value="${metaStrength}"
                checked
              >
              <label>${metaStrength}</label>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // -----------------------------
  // Product 4510438752355
  // -----------------------------
  if (productId === 4510438752355) {
    if (!metaStrength) return "";

    return `
      <div class="product_value eq-product-detail-strength__wrap-left eq-collection--height" data-input-type="radio">
        <div class="custom_variant_selection">
          <label>${labelText}</label>
          <div class="wrapper">
            <div class="form-grp">
              <input
                type="radio"
                class="custom-meta-strength"
                value="${metaStrength}"
                checked
              >
              <label>${metaStrength}</label>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // -----------------------------
  // Multiple variants
  // -----------------------------
  return `
    <div class="product_value eq-product-detail-strength__wrap-left">
      <div class="custom_variant_selection" data-option-1>
        <label>${labelText}</label>

        <div class="wrapper">

          ${variants
            .map((variant, i) => {
              const value = variant.title || "";

              // Skip 15mg for this product
              if (
                productId === 5995748753589 &&
                value === "15mg"
              ) {
                return "";
              }

              let checked = false;

              // Same checked logic as Liquid
              const hasDefaultStrengthMatch = defaultStrength
                    ? variants.some((v) =>
                        (v.title || "").includes(defaultStrength)
                      )
                    : false;

                  if (defaultStrength && hasDefaultStrengthMatch) {
                    checked = value.includes(defaultStrength);
                  } else {
                    // Fallback when defaultStrength is blank OR doesn't match any variant
                    if (value.includes("45mg")) {
                      checked = true;
                    } else if (i === 0) {
                      checked = true;
                    }
                  }

              let label = value;

              // Remove Strawberry Lemonade text
              if (productId === 4015032598627) {
                label = label
                  .replace("Strawberry Lemonade 30 pack", "")
                  .replace("Strawberry Lemonade 30 Pack", "");
              }

              return `
                <div class="form-grp">
                  <input
                    type="radio"
                    id="strength-${productId}-${index}-${i}"
                    class="pdp-radio--option"
                    value="${value.toLowerCase()}"
                    name="option-strength-${productId}"
                    ${checked ? "checked" : ""}
                  >
                  <label for="strength-${productId}-${index}-${i}">
                    ${label}
                  </label>
                </div>
              `;
            })
            .join("")}

        </div>
      </div>
    </div>
  `;
}

function renderSubscribeSection(p, subscriptionPrice) {
  return `
    <a href="javascript:;">
      <p>Subscribe & Save</p>
      <span class="subscription-price">$${subscriptionPrice}</span>
    </a>
    <div class="eq-product-price-dropdown js-eq-product-price-dropdown">
      <span>Delivery Frequency:</span>
      <select class="collection-sellingplan-dropdown">
        <option value="">Select Frequency</option>
        ${p.sellingPlans.map((sp) => `
          <option value="${sp.numericId}">${sp.name}</option>
        `).join("")}
      </select>
    </div>
  `;
}

// =========================
// RENDER BLOGS
// =========================
function renderBlogs(blogs) {
  const total = (blogs || []).length;
  const displayed = (blogs || []).slice(0, 8);

  const el = document.querySelector(".suggestions-product__blogs-row");
  const wrap = document.querySelector(".suggestions-product__blogs-wrap-button");
  const countEl = document.querySelector(".suggestions-product__blogs-result-text span");

  if (countEl) {
    countEl.innerHTML = `${total} Search Results for '${currentSearchQuery}'`;
  }

  if (!el) return;

  if (!displayed.length) {
    el.innerHTML = `<div class="no-blogs-found">No articles found</div>`;
    if (wrap) wrap.style.display = "none";
    return;
  }

  if (wrap) wrap.style.display = "block";

  el.innerHTML = displayed.map((article) => `
    <div class="suggestions-product__blogs-col">
      <a href="${article.url}" class="suggestions-product__blogs-block">
        <div class="suggestions-product__blogs-media">
          <div class="suggestions-product__blogs-image">
            <img src="${article.image || ""}" alt="${article.title || ""}">
          </div>
          ${article.isRewardPage ? "" : `<span class="suggestions-product__blogs-tag">Blog</span>`}
        </div>
        <div class="suggestions-product__blogs-detail">
          <div class="suggestions-product__blogs-title">
            <h6>${article.title || ""}</h6>
          </div>
        </div>
      </a>
    </div>
  `).join("");
}

// =========================
// RENDER SUGGESTIONS
// =========================
async function renderSuggestions(query) {
  const suggestions = await fetchPredictiveSuggestions(query);
  const el = document.querySelector(".search-suggestions__list ul");
  if (!el) return;

  el.innerHTML = suggestions.map((s) => `
    <li class="suggestion-item" data-keyword="${s.text}">
      <a href="javascript:void(0)" data-suggestion="${s.text}">
        <img data-suggestion="${s.text}" src="https://cdn.shopify.com/s/files/1/0265/5164/8355/files/seach-box-icon.png?v=1782811966">
        <span>${s.text}</span>
      </a>
    </li>
  `).join("");
}

// =========================
// BUILD FILTERS
// =========================
function buildFilters(products) {
  const el = document.querySelector(".js-benefits");
  if (!el) return;

  const available = new Set(
    products.flatMap((p) => (p.benefit || []).map((b) => b.trim().toLowerCase()))
  );

  const matched = ALL_BENEFIT_VALUES.filter((b) => available.has(b.toLowerCase()));

  if (!matched.length) {
    el.innerHTML = `<div class="no-benefits-found">No benefits found</div>`;
    return;
  }

  el.innerHTML = matched.map((b) => `
    <div class="suggestions-product__filters-option benefit-item" data-benefit="${b}">
      <input type="checkbox" id="benefit-${b}" onclick="onRedirect(currentSearchQuery)">
      <label for="benefit-${b}">
        <i class="suggestions-product__filters-checkbox"></i>
        <span class="suggestions-product__filters-opttext">${b}</span>
      </label>
    </div>
  `).join("");

  document.querySelectorAll(".benefit-item").forEach((item) => {
    item.addEventListener("mouseenter", function () {
      clearActiveFilters();
      this.classList.add("is-active-filter-option");
      handleBenefitClick.call(this);
      $(".pdp-radio--option:checked").trigger("change");
    });
  });
}

function buildCannabinoids(products) {
  const el = document.querySelector(".js-cannabinoids");
  if (!el) return;

  const available = new Set(
    products.flatMap((p) => (p.tags || []).map((t) => t.trim().toUpperCase()))
  );

  const matched = ALL_CANNA_VALUES.filter((c) => available.has(c.toUpperCase()));

  if (!matched.length) {
    el.innerHTML = `<div class="no-cannabinoids-found">No cannabinoids found</div>`;
    return;
  }

  el.innerHTML = matched.map((canna) => `
    <div class="suggestions-product__filters-option canna-item" data-canna="${canna}">
      <input type="checkbox" name="${canna}" value="${canna}" id="${canna}" onclick="onRedirect(currentSearchQuery)">
      <label for="${canna}">
        <i class="suggestions-product__filters-checkbox"></i>
        <span class="suggestions-product__filters-opttext">${canna}</span>
      </label>
    </div>
  `).join("");

  document.querySelectorAll(".canna-item").forEach((item) => {
    item.addEventListener("mouseenter", function () {
      clearActiveFilters();
      this.classList.add("is-active-filter-option");
      handleCannaClick.call(this);
      $(".pdp-radio--option:checked").trigger("change");
    });
  });
}

function buildCategoryFilters(products) {
  const el = document.querySelector(".js-category-filters");
  if (!el) return;

  const isCBGSearch = currentSearchQuery.toLowerCase().includes("cbg");

  const html = CATEGORY_FILTERS.reduce((acc, filter) => {
    const hasProducts = products.some(
      (p) => p.metafields?.[filter.metafield]?.trim()
    );

    if (!hasProducts && !(isCBGSearch && filter.metafield === "product_softgels")) {
      return acc;
    }

    return acc + `
      <div class="suggestions-product__filters-option category-filter-item" data-metafield="${filter.metafield}">
        <input type="checkbox" id="${filter.metafield}">
        <label for="${filter.metafield}">
          <i class="suggestions-product__filters-checkbox"></i>
          <span class="suggestions-product__filters-opttext">${filter.label}</span>
        </label>
      </div>
    `;
  }, "");

  el.innerHTML = html;

  document.querySelectorAll(".category-filter-item").forEach((item) => {
    item.addEventListener("mouseenter", function () {
      clearActiveFilters();
      this.classList.add("is-active-filter-option");

      const metafield = this.dataset.metafield;
      let filtered;

      if (isCBGSearch && metafield === "product_softgels") {
        filtered = allProducts.filter((p) =>
          (p.title || "").toLowerCase().includes("cbg softgel")
        );
      } else {
        filtered = allProducts.filter((p) => p.metafields?.[metafield]?.trim());
      }

      renderProducts(filtered);
      $(".pdp-radio--option:checked").trigger("change");
    });
  });
}

// =========================
// FILTER HELPERS
// =========================
function clearActiveFilters() {
  document
    .querySelectorAll(".benefit-item, .canna-item, .product-type-item, .category-filter-item")
    .forEach((el) => el.classList.remove("is-active-filter-option"));
}

function handleBenefitClick() {
  const val = this.dataset.benefit.toLowerCase();
  const filtered = allProducts.filter((p) =>
    (p.benefit || []).map((x) => x.toLowerCase()).includes(val)
  );
  renderProducts(filtered);
}

function handleCannaClick() {
  const val = (this.dataset.canna || "").toUpperCase();
  const filtered = allProducts.filter((p) =>
    (p.tags || []).map((t) => t.toUpperCase()).includes(val)
  );
  renderProducts(filtered);
}

// =========================
// REDIRECT
// =========================
function onRedirect(term) {
  storeRecentSearch(term);
  const encoded = encodeURIComponent(term);

  if (!term.length) {
    document.location = `${SEARCH_PAGE_URL}?q=*&pageIndex=1`;
  } else if (!activeFilterName) {
    document.location = `${SEARCH_PAGE_URL}?q=${encoded}&pageIndex=1`;
  } else {
    document.location = `${SEARCH_PAGE_URL}?q=${encoded}&${encodeURIComponent(activeFilterName)}=${encodeURIComponent(activeFilterVal)}&pageIndex=1`;
  }
}

// =========================
// RECENT SEARCHES
// =========================
function renderRecentSearches() {
  const wrapper = document.querySelector(".search-auto-popup__latest-searchs");
  const list = document.querySelector(".latest-searchs__list ul");
  if (!wrapper || !list) return;

  const recent = JSON.parse(localStorage.getItem("recentSearches") || "[]");

  if (!recent.length) {
    wrapper.style.display = "none";
    return;
  }

  wrapper.style.display = "flex";
  list.innerHTML = recent.map((term) => `
    <li>
      <a href="javascript:;" class="recent-search-item" data-search="${encodeURIComponent(term)}">
        <span>${term}</span>
        <img class="remove-recent-search" data-search="${encodeURIComponent(term)}"
          src="https://cdn.shopify.com/s/files/1/0265/5164/8355/files/remove-recent-search-icon.png?v=1782812386" alt="remove recent search">
      </a>
    </li>
  `).join("");
}

// =========================
// MATCH HEIGHT
// =========================
function initMatchHeight() {
  const selectors = [
    ".js-search-auto-popup .card > .card__content .card__heading .full-unstyled-link",
    ".js-search-auto-popup .card__content .eq-collection-benefits-badge",
    ".js-search-suggestions-popup .suggestions-product__product-row .card > .card__content .card__heading .full-unstyled-link",
    ".js-search-suggestions-popup .suggestions-product__product-row .card__content .eq-collection-benefits-badge",
    ".eq-product-detail-strength__wrap-left",
    ".js-eq-product-price--save-and-sub",
    ".js-search-suggestions-popup .js-eq-quiz-product-page-form"
  ];

  selectors.forEach(selector => {
        const $el = $(selector);

        if ($el.length) {
            $el.matchHeight('remove');
            $el.matchHeight({
                byRow: true
            });
        }
    });

    $.fn.matchHeight._update();
}

// =========================
// EVENT LISTENERS
// =========================
let lastHoveredKeyword = null;
let hoverTimeout = null;

document.addEventListener("mouseover", function (e) {
  const item = e.target.closest(".suggestion-item");
  if (!item) return;

  const keyword = (
    item.dataset.keyword || item.querySelector("a")?.dataset.suggestion || ""
  ).trim();

  if (!keyword || lastHoveredKeyword === keyword) return;
  lastHoveredKeyword = keyword;

  clearTimeout(hoverTimeout);
  hoverTimeout = setTimeout(async () => {
    openPopup();

    let products = await fetchProducts(keyword);
    products = applyOilProductRules(products, keyword);
    products = applyTinctureProductRules(products, keyword);
    currentSearchQuery = keyword;
    allProducts = products;

    renderProducts(allProducts);
    buildFilters(allProducts);
    buildCannabinoids(allProducts);
    buildCategoryFilters(allProducts);

    const resultText = document.querySelector(".suggestions-product__product-result-text span");
    if (resultText) {
      resultText.innerHTML = `${allProducts.length} Search Results for '${keyword}'`;
    }
  }, 200);
});



document.addEventListener("click", function (e) {
  const item = e.target.closest(".suggestion-item");
  if (!item) return;

  e.preventDefault();
  const keyword = (
    item.dataset.keyword || item.querySelector("a")?.dataset.suggestion || ""
  ).trim();

  if (keyword) {
    window.location.href = `/search?q=${encodeURIComponent(keyword)}&pageIndex=1`;
  }
});

document.addEventListener("click", (e) => {
  if (!e.target.closest(".search-wrapper")) closePopup();
});

document.addEventListener("click", function (e) {
  const removeBtn = e.target.closest(".remove-recent-search");
  if (!removeBtn) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  let recent = JSON.parse(localStorage.getItem("recentSearches") || "[]");
  const searchTerm = decodeURIComponent(removeBtn.dataset.search);

  recent = recent.filter((item) => item !== searchTerm);
  localStorage.setItem("recentSearches", JSON.stringify(recent));
  renderRecentSearches();
});

document.addEventListener("click", function (e) {
  if (e.target.closest(".remove-recent-search")) return;

  const item = e.target.closest(".recent-search-item");
  if (!item) return;

  const term = decodeURIComponent(item.dataset.search);
  const input = document.getElementById("cc-search-box");
  if (input) input.value = term;
  search(term);
});

document.addEventListener("DOMContentLoaded", function () {
  renderRecentSearches();
  initMatchHeight();

  const input = document.getElementById("cc-search-box");
  if (!input) return;

  let searchTimeout;

  input.addEventListener("focusin", function () {
    const val = this.value.trim();
    if (!val) return;

    openPopup();
    if (allProducts.length) {
      renderProducts(allProducts);
      buildFilters(allProducts);
      buildCannabinoids(allProducts);
      buildCategoryFilters(allProducts);
    } else {
      search(val);
    }
  });

  input.addEventListener("input", function () {
    const val = this.value.trim();
    clearTimeout(searchTimeout);

    if (!val) {
      closePopup();
      return;
    }

    searchTimeout = setTimeout(() => {
      openPopup();
      search(val);
    }, 300);
  });
}); 

$(document).on("focus", "#cc-search-box", function () {
  const val = $(this).val().trim();
  if (val) {
    openPopup();
    search(val);
  }
});
